import script from "./MeetingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MeetingCard.vue?vue&type=script&setup=true&lang=js"

import "./MeetingCard.vue?vue&type=style&index=0&id=c7a70e6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7a70e6e"]])

export default __exports__